<template>
    <VJoyDialog
        ref="dialogRef"
        :confirm-text="t('projectclient.general.pay.later.elligibility.modal.confirm.text')"
        :pattern-brand="true"
        data-test-id="pay-later-eligibility-success-modal"
        @dialog:hide="dialogRef?.hide({fireHideEvent: false})"
        @dialog:confirm="dialogRef?.hide({fireHideEvent: false})"
    >
        <template #dialog-header>{{ t('projectclient.general.pay.later.elligibility.modal.title') }}</template>
        <template #dialog-subheader>
            {{ t('projectclient.general.pay.later.elligibility.modal.description', [userStore.selectedIdentity?.clientCompanyName, paymentDelay]) }}
        </template>
        <template #dialog-body>
            <MaltIllustration
                name="rocket-launch--high"
                :alt="
                    t('projectclient.general.pay.later.elligibility.modal.description', [userStore.selectedIdentity?.clientCompanyName, paymentDelay])
                "
                width="210"
            />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {onScopeDispose, ref, useTemplateRef} from 'vue';
    import {MaltIllustration} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import {useUserStore} from '~/common/stores';
    import {eventBus} from '@/common/events';

    const userStore = useUserStore();

    const dialogRef = useTemplateRef('dialogRef');

    const paymentDelay = ref(30);

    const onDisplayPayLaterEligibilitySuccessModal = (delay?: number) => {
        dialogRef.value?.show();
        paymentDelay.value = delay ?? 30;
    };

    eventBus.on('displayPayLaterEligibilitySuccessModal', onDisplayPayLaterEligibilitySuccessModal);

    onScopeDispose(() => {
        eventBus.off('displayPayLaterEligibilitySuccessModal', onDisplayPayLaterEligibilitySuccessModal);
    });

    const {t} = useTranslation();
</script>
